module.exports = __webpack_public_path__ + "country_config.f236e45d4b8b41034661fc4d3bb47cbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/country_config.svg
// module id = 350
// module chunks = 0